import { FormStatus, FormStatusContext } from "components/Admin/Form/Form";
import { useContext } from "react";

export const useFormStatus = (): FormStatus => {
  const context = useContext(FormStatusContext);

  return context;
};